// @flow

export default {
    workerUrl: '',
    workerClass: null,
    workerParams: undefined,
};
